<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-05 14:54:07
 * @LastEditTime: 2021-12-10 10:20:38
 * @LastEditors: Please set LastEditors
 -->
<template lang="html">
    <el-menu :default-active="$route.path"  mode="horizontal" router 
    text-color="#fff" 
    background-color="#3e4756"
    >
      <h2 class="nav-title"><img class="logo" src="//yun.tuiapple.com/tuia/hunter/img/hunter-main-logo.png" alt=""></h2>
      <el-menu-item index="/home">页面性能</el-menu-item>
      <el-menu-item index="/report">性能报表</el-menu-item>
      <el-menu-item index="/doJoin">出券时间</el-menu-item>
      <el-menu-item index="/browser">设备特征</el-menu-item>
      <el-menu-item index="/ajax">AJAX</el-menu-item>
      <el-menu-item index="/sdk">安卓SDK</el-menu-item>
      <el-menu-item index="/iosSdk">IOSSDK</el-menu-item>
      <el-submenu index="2">
         <template slot="title" class="workplace">我的工作台</template>
         <el-menu-item index="/userBehavior">用户行为</el-menu-item>
         <el-menu-item index="/history">历史数据</el-menu-item>
         <el-menu-item index="/publish">发布耗时</el-menu-item>
      </el-submenu>
      <!-- <el-menu-item index="/kpi">KPI视图</el-menu-item>
      <el-menu-item index="/section">分段视图</el-menu-item> -->
      <li class="tip-pane">
        <el-select v-model="clientType" placeholder="请选择">
          <el-option
            v-for="item in clientTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <span class="name">{{userName}}</span>
        <span class="separator">|</span>
        <a class="logout" @click="logout()"><img class="logout-img" src="//yun.tuiapple.com/tuia/cdn/logout2.png" alt=""></a>
      </li>
    </el-menu>
</template>

<script>
import cookie from 'utils/cookie';
// import Vue from 'vue';
// import qs from 'qs';

export default {
  data() {
    const hrefArray = window.location.href.split('/');
    const activeIndex = hrefArray[hrefArray.length - 1];

    return {
      activeIndex,
      userName: '',
      user: '',

      clientType: '',
      clientTypeOptions: []
    };
  },
  mounted() {
    this.fetchUser()
    this.fetchClient()
    // this.fetchUser();
  },
  methods: {
    async logout() {
      try {
        await this.$http.get('/sso/logout')
        location.reload()
      } catch (error) {
        console.log(error)
      }
    },
    async fetchUser() {
      try {
        const res = await this.$http.get('/sso/admin')
        const {data} = res.data
        this.userName = data.name
        this.user = data
      } catch (error) {
        console.log(error)
      }
    },

    fetchClient() {
      this.$http
        .get('/timeRatio/types')
        .then(response => {
          const { data } = response.data;

          data.map(client => {
            this.clientTypeOptions.push({
              label: client,
              value: client
            });
            // this.clientType = this.clientTypeOptions ? this.clientTypeOptions[0].value : '';
            this.clientType = 'tuia';
          });

        })
        .catch(error => {
          console.error(error);
        });
    }
  },

  watch: {
    clientType: function(val) {
      this.$bus.$emit('clientChange', val);
      this.$bus.DATA.clientType = val;
    }
  }
};
</script>

<style lang="css">
.workplace {
  color: #fff !important;
}
.logo {
  width: 123px;
  height: 44px;
}
.nav-title {
  position: relative;
  float: left;
  margin: 8px 100px 0px 10px;
  outline: none;
}

/* .el-menu {
  padding: 0 20px;
  background-color: #3e4756;
} */

.el-menu-item {
  font-size: 16px;
  height: 60px !important;
  line-height: 60px !important;
  color: #fff !important;
}
.el-menu-item.is-active {
  background-color: #363c48 !important;
  border-bottom: 3px solid #579add !important;
  border-bottom-color: #579add !important;
}
.el-menu-item:hover {
  background-color: #363c48 !important;
  border-bottom: 3px solid #579add !important;
  border-bottom-color: #579add !important;
}
.el-submenu__title {
  color: #fff !important;
}
/* .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    color: #fff;
} */
/* .el-submenu {
  color: #fff !important;
} */

.name {
  color: #fff;
}
.separator {
  color: #fff;
  margin-left: 10px;
}
.logout {
  margin-left: 10px;
}
.tip-pane {
  float: right;
  height: 60px !important;
  line-height: 60px !important;
  outline: none;
}
</style>
